"use client";

import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import withMetaData from "hoc/withMetaData";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import isHighTrafficPage from "util/helper/isHighTrafficPage";
import { COMPARE_COMPETITOR_PAGES, COMPETITOR_PAGES } from "./static-page-constants";

const CareersInAutomotiveIndustry = dynamic(() => import(/* webpackChunkName: "careers-automotive-industry" */"./careers-in-automotive-industry"));
const Careers = dynamic(() => import(/* webpackChunkName: "careers" */"./Careers"));
const FreeShiping = dynamic(() => import(/* webpackChunkName: "free-shiping" */"./free-shipping"));
const AboutPartsavataCanada = dynamic(() => import(/* webpackChunkName: "about-partsavatar-canada" */"./about-partsavatar-canada"));
const AboutUs = dynamic(() => import(/* webpackChunkName: "about-us" */"./about-us"));
const Team = dynamic(() => import(/* webpackChunkName: "team" */"./team"));
const AfterMarketPartsReturnPolicy = dynamic(() => import(/* webpackChunkName:
   "aftermarket-parts-return-policy" */"./aftermarket-parts-return-policy"
), { loading: () => <LoaderSkeleton height={1200} /> });
const Returns = dynamic(() => import(/* webpackChunkName:
   "Returns" */"./returns"
), { loading: () => <LoaderSkeleton height={1200} /> });
const RapidDelivery = dynamic(() => import(/* webpackChunkName:
   "Rapid-Delivery" */"./rapid-delivery"
), { loading: () => <LoaderSkeleton height={1200} /> });
const AutoPartsFreeShipping = dynamic(() => import(/* webpackChunkName:
  "auto-parts-free-shipping-canada" */"./auto-parts-free-shipping-canada"
), { loading: () => <LoaderSkeleton height={1200} /> });

const ContactUs = dynamic(() => import(/* webpackChunkName:
  "contact-us-for-car-parts" */"./contact-us-for-car-parts"
), { loading: () => <LoaderSkeleton height={1200} /> });

const CarPartnews = dynamic(() => import(/* webpackChunkName:
  "car-parts-news-in-canada" */"./car-parts-news-in-canada"
), { loading: () => <LoaderSkeleton height={1200} /> });

const FAQs = dynamic(() => import(/* webpackChunkName:
  "questions-about-autoparts" */"./questions-about-autoparts"
), { loading: () => <LoaderSkeleton height={1200} /> });

const PredictiveViewAll = dynamic(() => import(/* webpackChunkName:
  "predictive-viewall" */"./predictive-viewall"
), { loading: () => <LoaderSkeleton height={1200} /> });

const ReturnAutomotiveParts = dynamic(() => import(/* webpackChunkName:
  "return-automotive-parts" */"./return-automotive-parts"
), { loading: () => <LoaderSkeleton height={1200} /> });

const InstorePickup = dynamic(() => import(/* webpackChunkName:
  "in-store-pickup" */ "./in-store-pickup"
), { loading: () => <LoaderSkeleton height={1200} /> });

const Financing = dynamic(() => import(/* webpackChunkName:
  "financing" */"./financing"
), {
  loading: () => <LoaderSkeleton height={1200} />,
});
const TireCalculator = dynamic(() => import(/* webpackChunkName: "tire-calculator" */ "./tire-calculator"), {
  loading: () => <LoaderSkeleton height={1200} />,
});

const WarrantyPolicy = dynamic(() => import(/* webpackChunkName: "warranty-on-auto-parts" */ "./warranty-on-auto-parts"), {
  loading: () => <LoaderSkeleton height={1200} />,
});

const WheelsTires = dynamic(() => import(/* webpackChunkName:
  "wheels-tires" */"./wheels-tires"
), { loading: () => <LoaderSkeleton height={1200} /> });

const NewsletterSignup = dynamic(() => import(/* webpackChunkName: "NewsletterSignup" */"./newsletter-signup/NewsletterSignup"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const SsrProductContainer = dynamic(() => import(/* webpackChunkName:
  "ssr-product-container" */"component/category/SsrProductContainer"
), { loading: () => <LoaderSkeleton height={1200} /> });

const CompetitorPage = dynamic(() => import(/* webpackChunkName: "competitor-page" */"./competitor-page/CompetitorPage"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const CarParts = dynamic(() => import(/* webpackChunkName: "car-parts" */"./CarParts"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const CompareThreePages = dynamic(() => import(/* webpackChunkName: "compare-three-competitor-pages" */"./competitor-page/CompareThreePages"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const CompareCompetitorPage = dynamic(() => import(/* webpackChunkName: "compare-competitor-pages" */"./competitor-page/CompareCompetitorPage"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const Apparel = dynamic(() => import(/* webpackChunkName: "apparel-static-page" */"./apparel/Apparel"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const EmailPreference = dynamic(() => import(/* webpackChunkName: "email-preference" */"./email-preference/EmailPreference"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const ProudlyCanadianPage = dynamic(() => import(/* webpackChunkName: "proudly-canadian" */"./proudly-canadian-page/ProudlyCanadianPage"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const Rewards = dynamic(() => import(/* webpackChunkName: "rewards" */"./rewards/Rewards"),
  { loading: () => <LoaderSkeleton height={1200} /> });

const StaticPage = dynamic(() => import(/* webpackChunkName: "static-page" */"./StaticPage"),
  { loading: () => <LoaderSkeleton height={1200} /> });

function Index(inPutProps: any) {
  const router = useRouter();
  const {
    staticData, actualResponse, pageType, // pageContent,
  } = inPutProps;
  const { pathname } = router.query;
  // const [finalStaticData, setFinalStaticData] = useState();
  // const [finalActualResponse, setFinalActualResponse] = useState();

  const props = {
    staticData,
    actualResponse,
    pageType,
  };
  // const pagesNotRequiredApiCall = ["predictive-viewall", "rock-auto", "wheels-tires",
  //   "careers-in-automotive-industry", "free-shipping",
  //   "car-parts-news-in-canada", "tire-calculator", "newsletter-sign-up"];

  // useEffect(() => {
  //   if (pagesNotRequiredApiCall.includes(pathname)) {
  //     return;
  //   }
  //   setFinalActualResponse(null);
  //   /* Clear Previous data because if we go from one static page to another. Old data was being passed.
  //   Ex ->  aftermarket-parts-return-policy -> in-store-pickup  */
  //   setFinalStaticData(null);
  //   const cleanQP = { url: pathname };
  //   const requestUrl = `s/get-page-details-v3?${qs.stringify(cleanQP, {
  //     sort: (a: any, b: any) => API_PARAM_ORDERS.indexOf(b) - API_PARAM_ORDERS.indexOf(a),
  //   })}`;
  //   axios.get(requestUrl)
  //     .then(({ data }) => {
  //       setFinalActualResponse(data.actualResponse);
  //       setFinalStaticData(data.pageContent);
  //     });
  // }, [pathname]);

  // if (!pagesNotRequiredApiCall.includes(pathname) && !finalActualResponse && !finalStaticData) {
  //   return null;
  // }

  if (pathname === "careers-in-automotive-industry") {
    return <CareersInAutomotiveIndustry />;
  }
  if (pathname === "free-shipping") {
    return <FreeShiping />;
  }
  if (pathname === "about-partsavatar-canada") {
    return <AboutPartsavataCanada {...props} />;
  }
  if (pathname === "careers") {
    return <Careers />;
  }
  if (pathname === "about-us") {
    return <AboutUs {...staticData} />;
  }
  if (pathname === "team") {
    return <Team />;
  }
  if (pathname === "aftermarket-parts-return-policy") {
    return <AfterMarketPartsReturnPolicy {...props} />;
  }
  if (pathname === "returns") {
    return <Returns {...props} />;
  }
  if (pathname === "rapid-delivery") {
    return <RapidDelivery {...props} />;
  }
  if (pathname === "auto-parts-free-shipping-canada") {
    return <AutoPartsFreeShipping {...props} />;
  }
  if (pathname === "contact-us-for-car-parts") {
    return <ContactUs {...props} />;
  }
  if (pathname === "car-parts-news-in-canada") {
    return <CarPartnews />;
  }
  if (pathname === "questions-about-autoparts") {
    return <FAQs {...props} />;
  }
  if (pathname === "predictive-viewall") {
    return <PredictiveViewAll />;
  }
  if (pathname === "return-automotive-parts") {
    return <ReturnAutomotiveParts {...props} />;
  }
  if (pathname === "in-store-pickup") {
    return <InstorePickup {...props} />;
  }
  if (pathname === "financing") {
    return <Financing {...props} />;
  }
  if (pathname === "tire-calculator") {
    return <TireCalculator />;
  }
  if (pathname === "warranty-on-auto-parts") {
    return <WarrantyPolicy {...props} />;
  }
  if (pathname === "wheels-tires") {
    return <WheelsTires {...staticData} />;
  }

  if (pathname === "newsletter-sign-up") {
    return <NewsletterSignup />;
  }

  if (["all-parts", "b2b"].includes(pathname)) {
    return <SsrProductContainer {...props.staticData} />;
  }
  if (isHighTrafficPage(router)) {
    return <CarParts homeJson={props.staticData} />;
  }
  if (COMPETITOR_PAGES.includes(pathname) && !COMPARE_COMPETITOR_PAGES.includes(pathname)) {
    return <CompetitorPage staticData={props.staticData} />;
  }
  if (["carid-rockauto-tdot-general", "eastgate-toyotadirect-make-specific"].includes(pathname)) {
    return <CompareThreePages staticData={props.staticData} />;
  }

  if (COMPARE_COMPETITOR_PAGES.includes(pathname)) {
    return <CompareCompetitorPage staticData={props.staticData} />;
  }

  if (pathname === "apparel") {
    return <Apparel staticData={props.staticData} />;
  }

  if (pathname === "email-preference") {
    return <EmailPreference />;
  }

  if (pathname === "proudly-canadian") {
    return <ProudlyCanadianPage staticData={props.staticData} />;
  }

  if (pathname === "rewards") {
    return <Rewards {...props} />;
  }

  return (
    <StaticPage staticData={staticData} />
  );
}

export default withMetaData(Index);
